import styled from '@emotion/styled';
import { ClassAttributes, createElement } from 'react';

type Props = ClassAttributes<HTMLElement> & {
  src: string;
  imageRef?: (el: HTMLImageElement) => void;
  clickable?: boolean;
  className?: string;
};

const ImageScreen = ({ src, imageRef = () => undefined, clickable = false, className }: Props) => {
  return clickable ? (
    <AnchorLink href={src} target="_blank" className={className}>
      <Img src={src} ref={imageRef} />
    </AnchorLink>
  ) : (
    <Img src={src} ref={imageRef} className={className} />
  );
};

const AnchorLink = styled('a')({
  display: 'flex',
  alignItems: 'center',
});

const Img = styled('img')({
  background: '#000',
  objectFit: 'contain',
  maxWidth: '100%',
  maxHeight: '100%',
}) as any;

export default ImageScreen;
